<template>
  <PageSection
    :use-alternate-bg-color="useAlternateBgColor"
  >
    <PageContainer>
      <PageHeading tag-name="h1">
        {{ $t('csr.section.partners.title') }}
      </PageHeading>
    </PageContainer>

    <CsrLogoWrapper>
      <template v-slot="{ itemClass }">
        <img
          v-for="item in items"
          :key="item"
          :class="itemClass"
          :src="item"
        >
      </template>
    </CsrLogoWrapper>
  </PageSection>
</template>

<script lang="ts">
import PageHeading from '@/scripts/pages/onepager/components/PageHeading.ts.vue';
import PageTwoColumnsContent from '@/scripts/pages/onepager/components/PageTwoColumnsContent.ts.vue';
import PageSection from '@/scripts/pages/onepager/components/PageSection.ts.vue';
import PageContainer from '@/scripts/pages/onepager/components/PageContainer.ts.vue';
import { CsrBaseComponent } from '../components/CsrBaseComponent';
import CsrLogoWrapper from '../components/CsrLogoWrapper.ts.vue';
import { PARTNERS_SECTION_IMAGES } from '../assets/media';

export default CsrBaseComponent.extend({
  components: {
    PageHeading,
    PageTwoColumnsContent,
    PageSection,
    PageContainer,
    CsrLogoWrapper,
  },
  props: {
    useAlternateBgColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: PARTNERS_SECTION_IMAGES,
    };
  },
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';
</style>
